import React, { useEffect } from 'react'

import store from '@/redux/store'
import { isMeinBuero } from '@/utils/build-env'

import ConfirmEmailModal, { CONFIRM_EMAIL_VARIANTS } from '@/modules/account/components/confirm-email/confirm-email-modal'
import { updateSubscriptionDetails } from '@/redux/ducks/subscription/details'
import { trackOrgamaxGaEvent } from '../base/helpers/trackOrgamaxGaEvent'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const isMB = isMeinBuero()
let isComponentRendered = false

// the registration variant (step 1 of 3) is only for the onboarding gate - the soft reminders after the
// registration (hint, notification, menu bar) open the plain modal
const openConfirmEmailModal = ({ showLogout = false, isRegistration = false } = {}) => {
  if (isMB) { return }

  const { tenant: { info: { subscriptions } } } = store.getState()
  const subscriptionTypeTypesLabel = subscriptions?.map(s => s.typeOfSubscription).join(', ') || ''

  const getComponent = (closeFunction) => {
    const handleClose = () => {
      closeFunction()
      isComponentRendered = false
    }

    const Wrapper = () => {
      useEffect(() => () => { isComponentRendered = false }, [])
      return (
        <ConfirmEmailModal
          showLogout={showLogout}
          variant={isRegistration ? CONFIRM_EMAIL_VARIANTS.registration : CONFIRM_EMAIL_VARIANTS.default}
          closeModal={handleClose}
          onConfirm={() => {
            handleClose()
            updateSubscriptionDetails(true, true)
          }}
          open
          isModal
          gaData={{
            eventCategory: 'DOI',
            eventAction: 'afterRegister',
            eventLabel: `DOI durchgeführt ${subscriptionTypeTypesLabel}`,
          }}
        />
      )
    }

    return <Wrapper />
  }

  if (!isComponentRendered && renderElement) {
    trackOrgamaxGaEvent('Register', 'Registrierung', `Erster Screen ${subscriptionTypeTypesLabel}`)
    try {
      renderElement(getComponent)
      isComponentRendered = true
    } catch (e) {
      isComponentRendered = false
      throw e
    }
  }
}

export const isConfirmEmailOpen = () => isComponentRendered
export const setConfirmEmailOpen = (value) => { isComponentRendered = value }

export default openConfirmEmailModal
